export const ImageAttachments = [
  'image/png',
  'image/jpeg',
  'image/jpg',
  'image/gif',
]
